export interface Project {
    id: string;
    name: string;
    apiKey: string;
    googleProjectId?: string | null;
    googleLocation?: string | null;
    order: number;
    createdAt?: string;
    updatedAt?: string;
}

export type ProjectFormData = Omit<Project, 'id' | 'createdAt' | 'updatedAt'>;

export const DEFAULT_PROJECT_CONFIG: Omit<Project, 'id' | 'name' | 'apiKey'> = {
    order: 0,
};
